import { widthEm, isPortrait } from '../size';

export const formatVolunteerFormData = (volunteerOpportunity, volunteerFormData) => {
    return Object.keys(volunteerFormData)
        .filter(k => k.includes('question|'))
        .map(k => {
            let id = parseInt(k.split('|')[1], 10);
            let label = volunteerOpportunity.questions.filter(q => q.id === id)[0].label;
            let values = Array.isArray(volunteerFormData[`question|${id}`])
                ? volunteerFormData[`question|${id}`]
                : [volunteerFormData[`question|${id}`]];

            return Object.assign(
                {},
                {
                    id,
                    label,
                    values
                }
            );
        });
};

export const replaceLocale = state => {
    if (state.volunteer.postalCode) {
        return state.volunteer.postalCode;
    }
    if ((state.widget.endUserLocation || {}).regionName) {
        return state.widget.endUserLocation.regionName;
    }
    return '';
};

export const normalizeOpportunityName = (name = '') => {
    return name === name.toUpperCase()
        ? name
              .toLowerCase()
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')
        : name;
};

export const truncateOpportunityTitle = (title, isPortrait) => {
    if (!title) return;
    const mobileRatio = widthEm() / 19.5;
    const desktopRatio = widthEm() / 38.5;
    const charLimit = Math.floor(isPortrait ? mobileRatio * 50 : desktopRatio * 90);
    return title.length > charLimit ? title.substring(0, charLimit - 3) + '...' : title;
};

export const truncateOpportunityDescription = (
    description,
    actionsLength,
    isPortrait
) => {
    if (!description) return;
    if (!isPortrait) return description;
    const mobileRatio = widthEm() / 19.5;
    const desktopRatio = widthEm() / 38.5;

    const charLimit = Math.floor(
        isPortrait ? mobileRatio * 240 : actionsLength < 3 ? 100 : desktopRatio * 140
    );

    return description.length > charLimit
        ? description.substring(0, charLimit - 3) + '...'
        : description;
};

export const truncateTitle = title => {
    const markupChars = title.indexOf(`<span id="partnerName">`) !== -1 ? 30 : 0;
    const estimatedCharacters = Math.floor(widthEm() * 2.666);
    if (estimatedCharacters < title.length) {
        return isPortrait()
            ? title.slice(0, estimatedCharacters * 1.25 - 3 + markupChars) + '...'
            : title;
    }
    return title;
};
